ixModuleRouting("impactx.excelimportbaskets", {
    "/excelimportbaskets": {
        template: "<ixa-excel-import-baskets></ixa-excel-import-baskets>",
        templateUrl:
            "modules/excelimportbaskets/templates/excelimportbaskets.html",
        controller: "ExcelImportBasketsCtrl",
        controllerAs: "excelImportBasketsCtrl",
        workspace: "shop",
    },
});
